import { SettingsInfo } from './SettingsInfo'
import { useTrackEvent } from '../../mixpanel/useTrackEvent'
import {
  Input2,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  useNotifications,
} from '@valuecase/ui-components'
import { useCompanyVisualSettings } from './hooks/useCompanyVisualSettings'
import { useEffect, useState } from 'react'
import { TTenant } from '@valuecase/common'

type IntercomApiBaseValue = NonNullable<TTenant['intercomApiBase']>

export const BuyerIntercomSetting = () => {
  const { success } = useNotifications()
  const { trackEvent } = useTrackEvent()
  const [intercomId, setIntercomId] = useState('')
  const [intercomApiBase, setIntercomApiBase] = useState<TTenant['intercomApiBase']>(
    'https://api.eu.intercom.io',
  )
  const { companySettings, updateCompanySettings } = useCompanyVisualSettings({
    onUpdateSuccess: () => {
      success('Intercom ID updated')
    },
  })

  useEffect(() => {
    setIntercomId(companySettings?.intercomId || '')
    if (companySettings?.intercomApiBase) {
      setIntercomApiBase(companySettings.intercomApiBase)
    }
  }, [companySettings])

  function updateIntercomId() {
    trackEvent({
      event: 'settings-update_buyer_intercom_id',
      eventProperties: {
        indexPageName: 'Company Settings',
      },
    })
    updateCompanySettings({ intercomId })
  }

  function updateIntercomApiBase(value: IntercomApiBaseValue) {
    setIntercomApiBase(value)
    updateCompanySettings({ intercomApiBase: value })
  }

  function handleInput(e: string) {
    setIntercomId(e)
  }

  const intercomApiBaseOptions: Array<{ value: IntercomApiBaseValue; label: string }> = [
    { value: 'https://api.eu.intercom.io', label: 'EU – https://api.eu.intercom.io' },
    { value: 'https://api.intercom.io', label: 'US – https://api.intercom.io' },
  ]

  function getIntercomApiBaseDisplayText(value: string | null) {
    if (!value) return ''
    return intercomApiBaseOptions.find((option) => option.value === value)?.label || value
  }

  return (
    <div className='flex justify-between w-full items-start'>
      <SettingsInfo
        title='Intercom'
        description='Connect your Intercom account to your spaces to enable live chat with your customers.'
      />

      <div className='relative flex flex-col gap-2 items-end'>
        <Input2
          className='w-64'
          placeholder='Intercom ID'
          value={intercomId}
          onBlur={updateIntercomId}
          onChange={(e) => handleInput(e.target.value)}
        />

        {intercomId && (
          <Select value={intercomApiBase || undefined} onValueChange={updateIntercomApiBase}>
            <SelectTrigger className='w-64'>
              <SelectValue>{getIntercomApiBaseDisplayText(intercomApiBase)}</SelectValue>
            </SelectTrigger>
            <SelectContent>
              {intercomApiBaseOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
    </div>
  )
}
